import Api from "~/service/Api";

class ProviderTaxYearPurchaseReportRepository {
  fetchOne(query) {
    return Api.get(`/provider/tax-year-purchase-reports`, query);
  }
}

export default ProviderTaxYearPurchaseReportRepository;
